// Shared palette for the landing product mockups — matched to the real (dark) Mobeat panel so the
// code-rendered visuals read like the actual product. Dummy data only; no customer data.
export const MOBEAT_VIS = {
  bg: '#0F1013',
  panel: '#17181C',
  tile: '#1D1E23',
  border: 'rgba(255,255,255,0.08)',
  grid: 'rgba(255,255,255,0.07)',
  text: '#EDEEF0',
  dim: 'rgba(255,255,255,0.5)',
  blue: '#2E90E6', // new revenue / new customers / set to cancel
  teal: '#2BC0B0', // renewal / trials
  green: '#2FA96E', // set to renew / converted
  gold: '#C4A02C', // cohort matrix / pending / totals accent
  red: '#CB4B5E', // billing issue / abandoned
};
